import React from 'react';

const TaskListAlt = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 4.978
      }}
      d="M27.8,29.8H4.2c-0.7,0-1.2-0.5-1.2-1.2V4.2C3,3.5,3.6,3,4.2,3h23.6C28.4,3,29,3.5,29,4.2v24.4  C29,29.3,28.4,29.8,27.8,29.8z"
    />
    <g
      fill="none"
      stroke="#6f6f71"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="4.978"
      transform="translate(0,5)"
    >
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m15.1 10h9.4"
      />
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m15.1 12.8h5.6"
      />
    </g>
    <g id="g8575_2_" transform="translate(47.5,74.5)">
      <path
        id="path8577_2_"
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m-40.9-58.4 1.5 1.9 3.3-3.3"
      />
    </g>
    {/* <g
      fill="none"
      stroke="#6f6f71"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="4.978"
    >
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m15.1 19.8h9.4"
      />
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m15.1 22.6h5.6"
      />
    </g>
    <g id="g8575_1_" transform="translate(47.5,69.5)">
      <path
        id="path8577_1_"
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="M-40.9-48.6l1.5,1.9L-36-50"
      />
    </g> */}
  </svg>
);

export default TaskListAlt;
